export default __webpack_public_path__ + "static/media/3.63945d63.png";